export default __webpack_public_path__ + "static/landing-diagram-57aac3dffedef71f97b848df21535a76.png";